import script from "./esOrderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./esOrderDetail.vue?vue&type=script&setup=true&lang=js"

import "./esOrderDetail.vue?vue&type=style&index=0&id=472018fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-472018fc"]])

export default __exports__